import { useState } from 'react';
import repo from 'service/repository';
import ButtonDialog from 'components/button-dialog';
import DialogLayout from 'components/dialog-layout';
import Button from 'components/button';
import { useAppContext, UPDATE_USER_INFO, SHOW_APP_MESSAGE } from 'use-app';
import { marketingConsentUrl } from 'config';
import styles from './marketing-email-optedin-dialog.module.sass';

const useSubmitMarketingEmailOptedIn = () => {
  const { dispatch: appDispatch, hideMarketingEmailOptedInDialog } = useAppContext();
  const submit = () => {
    return repo
      .updateUserInfo(undefined, undefined, undefined, undefined, true)
      .then(value => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });

        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: 'success',
            message: '設定成功',
          },
        });
        hideMarketingEmailOptedInDialog();
      })
      .catch(error => {});
  };
  return submit;
};

const Modal = ({ isShow, setIsShow }) => {
  return (
    <DialogLayout className={styles.modal} contentClassName={styles.modalContent} isShow={isShow}>
      <div className={styles['iframe']}>
        <iframe title={'marketingConsent'} src={marketingConsentUrl} id="marketingConsent" />
      </div>
      <div className={styles.actions}>
        <Button
          onClick={() => {
            setIsShow(false);
          }}
        >
          關閉
        </Button>
      </div>
    </DialogLayout>
  );
};

export const Content = () => {
  const [isShow, setIsShow] = useState(false);
  return (
    <>
      <Modal {...{ isShow, setIsShow }} />
      <div className={styles['content']}>
        同意車麻吉使用我的電子郵件，以寄送行銷活動、會員優惠與最新資訊。您可隨時於信件中取消訂閱。（
        <span className={styles['action']} onClick={setIsShow}>
          直接行銷同意條款
        </span>
        ）
      </div>
    </>
  );
};

export const MarketingEmailOptedInDialog = () => {
  const { state: appState, hideMarketingEmailOptedInDialog } = useAppContext();
  const submit = useSubmitMarketingEmailOptedIn();

  return (
    <ButtonDialog
      isShow={appState.isShowMarketingEmailOptedInDialog}
      horizonal
      title="同意直接行銷信件"
      items={[
        {
          theme: 'positive',
          content: '同意',
          onClick: () => {
            submit();
          },
        },
        {
          theme: 'cancel',
          content: '取消',
          onClick: hideMarketingEmailOptedInDialog,
        },
      ]}
    >
      <Content />
    </ButtonDialog>
  );
};
